import { render, staticRenderFns } from "./LoadingForm.vue?vue&type=template&id=383e9214&scoped=true"
import script from "./LoadingForm.vue?vue&type=script&lang=js"
export * from "./LoadingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383e9214",
  null
  
)

export default component.exports